import { __assign, __rest } from "tslib";
import React from 'react';
import { TableHead as MUTableHead } from '@material-ui/core';
export var TableHead = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React.createElement(MUTableHead, __assign({}, props), children);
};
//# sourceMappingURL=TableHead.js.map